import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowRight, Shield, Users } from 'lucide-react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Content from '../components/layout/Content';
import RolesManagement from './permissions/RolesManagement';
import UserPermissions from './permissions/UserPermissions';

type PermissionModuleCardProps = {
    title: string;
    description: string;
    icon: React.ElementType;
    onClick: () => void;
};

const PermissionModuleCard = ({ title, description, icon: Icon, onClick }: PermissionModuleCardProps) => {
    return (
        <Card className='cursor-pointer hover:shadow-lg transition-shadow' onClick={onClick}>
            <CardHeader className='flex flex-row items-center gap-4'>
                <div className='p-2 bg-primary/10 rounded-lg'>
                    <Icon className='h-6 w-6 text-primary' />
                </div>
                <div>
                    <CardTitle className='text-lg'>{title}</CardTitle>
                </div>
            </CardHeader>
            <CardContent>
                <CardDescription className='mb-4'>{description}</CardDescription>
                <div className='flex justify-end'>
                    <Button variant='ghost' size='sm'>
                        <ArrowRight className='h-4 w-4' />
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

const PermissionsHome = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <h1 className='text-3xl font-bold mb-2'>Berechtigungen</h1>
                <p className='text-muted-foreground mb-8'>
                    Verwalten Sie Rollen und Benutzerberechtigungen für das System.
                </p>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                    <PermissionModuleCard
                        title='Rollen'
                        description='Erstellen und verwalten Sie Rollen mit Berechtigungsgruppen. Rollen können mehreren Benutzern zugewiesen werden.'
                        icon={Shield}
                        onClick={() => navigate('/permissions/roles')}
                    />
                    <PermissionModuleCard
                        title='Benutzerberechtigungen'
                        description='Weisen Sie Benutzern Rollen zu oder erteilen Sie direkte Berechtigungen für einzelne Benutzer.'
                        icon={Users}
                        onClick={() => navigate('/permissions/users')}
                    />
                </div>
            </div>
        </Content>
    );
};

const Permissions = () => {
    return (
        <Routes>
            <Route path='/' element={<PermissionsHome />} />
            <Route path='/roles/*' element={<RolesManagement />} />
            <Route path='/users/*' element={<UserPermissions />} />
        </Routes>
    );
};

export default Permissions;
